// Web/FrogOne.WebUI.Admin/src/app/features/parking/customergroups/edit/setoccupancy/setoccupancy.component.ts
import { Component, OnInit } from '@angular/core';
import { SimpleModalComponent } from '@looorent/ngx-simple-modal';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiService } from 'src/app/Services/api.service';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-setoccupancy',
    templateUrl: './setoccupancy.component.html',
    styleUrls: ['./setoccupancy.component.scss'],
    standalone: false
})
export class SetOccupancyComponent extends SimpleModalComponent<any, any> implements OnInit {
  
  public ModelId: number = 0;
  public currentOccupancy: number = 0;
  public Form: FormGroup;

  constructor(
    private apiService: ApiService,
    private formBuilder: FormBuilder,
    private toast: ToastrService
  ) {
    super();
    this.Form = this.formBuilder.group({
      occupancy: [0, [Validators.required, Validators.min(0)]]
    });
  }

  ngOnInit(): void {
    this.Form.patchValue({ occupancy: this.currentOccupancy });
  }

  public UpdateOccupancy(): void {
    if (this.Form.valid) {
      const newOccupancy = this.Form.get('occupancy')?.value;
      
      this.apiService.Put(`parking/customergroups/${this.ModelId}/occupancy/${newOccupancy}`, null)
        .then(result => {
          this.toast.success('Occupancy updated successfully', 'Saved');
          this.result = true;
          this.close();
        })
        .catch(error => {
          this.toast.error('Failed to update occupancy', 'Error');
        });
    }
  }

  public Cancel(): void {
    this.result = false;
    this.close();
  }
}
